module.exports = __webpack_public_path__ + "static/img/dzda-bg.de8cac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/dzda-bg.png
// module id = C7l1
// module chunks = 96